import { render, staticRenderFns } from "./Quizs.vue?vue&type=template&id=3d14bfe5&"
import script from "./Quizs.vue?vue&type=script&lang=js&"
export * from "./Quizs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports